/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

import Card from "src/components/cards/Card.react";
import TableStiffener from "src/views/report/custom/TableStiffener.react";

/**
 * The Blade component
 *
 * @author Thais Watanabe
 */
const Blade = (props) => {
  const {
    turbineInspection,
    inspectionModelItems,
    results,
    openEdit,
    openObs,
    inspection,
  } = props;

  // 11
  const i11 = inspectionModelItems.filter((obj) => obj.name === "11-4")?.[0];

  // 11-4
  const r11_4 = results.filter((obj) => obj.itemId === "11-4")?.[0];

  // 11-5
  const r11_5 = results.filter((obj) => obj.itemId === "11-5")?.[0];

  // 11-6
  const r11_6 = results.filter((obj) => obj.itemId === "11-6")?.[0];

  // 11-7
  const i11_7 = inspectionModelItems.filter((obj) => obj.name === "11-7")?.[0];
  const r11_7 = results.filter((obj) => obj.itemId === "11-7")?.[0];

  return (
    <>
      <Card title="スティフナー写真撮影記録表" className="print:mt-2">
        <TableStiffener
          inspection={inspection}
          openEdit={openEdit}
          openObs={openObs}
          turbineInspection={turbineInspection}
          i11={i11}
          r11_4={r11_4}
          r11_5={r11_5}
          r11_6={r11_6}
        />
      </Card>

      <Card title="ライトニングケーブル写真撮影記録表" className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center w-5 print:hidden">
                <ResultDropdown
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i11_7}
                  turbineInspection={turbineInspection}
                  selectedResult={r11_7}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center w-52">軸</ColHeader>
              <ColHeader className="text-center w-52">
                インシュレーション
                <br />
                ブッシュ部
              </ColHeader>
              <ColHeader className="text-center w-52">中間端子部</ColHeader>
              <ColHeader className="text-center w-52">
                根元側
                <br />
                ケーブル部
              </ColHeader>
            </tr>
          </thead>
          <TableBody>
            {/* 1 */}
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">1</Col>
              {[...Array(3)].map((x, i) => (
                <Col className="text-center" key={i}>
                  <ResultBadge
                    result={r11_7?.childrenResults[i] ?? "-"}
                    unit={i11?.inspectionModelItemChildren.items?.[i].unit}
                    isInputCorrect={isInputCorrect(
                      i11_7?.name,
                      r11_7?.childrenResults[i] ?? "-",
                      i
                    )}
                  />
                </Col>
              ))}
            </tr>
            {/* 2 */}
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">2</Col>
              {[...Array(3)].map((x, i) => (
                <Col className="text-center" key={i}>
                  <ResultBadge
                    result={r11_7?.childrenResults[i + 3] ?? "-"}
                    unit={i11?.inspectionModelItemChildren.items?.[i + 3].unit}
                    isInputCorrect={isInputCorrect(
                      i11_7?.name,
                      r11_7?.childrenResults[i + 3] ?? "-",
                      i + 3
                    )}
                  />
                </Col>
              ))}
            </tr>
            {/* 3 */}
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">3</Col>
              {[...Array(3)].map((x, i) => (
                <Col className="text-center" key={i}>
                  <ResultBadge
                    result={r11_7?.childrenResults[i + 6] ?? "-"}
                    unit={i11?.inspectionModelItemChildren.items?.[i + 6].unit}
                    isInputCorrect={isInputCorrect(
                      i11_7?.name,
                      r11_7?.childrenResults[i + 6] ?? "-",
                      i + 6
                    )}
                  />
                </Col>
              ))}
            </tr>
          </TableBody>
        </Table>
      </Card>
    </>
  );
};

export default Blade;
